<template>
    <div class="toolbar">
        <div class="container">
            <div class="row" style="display: flex; align-items: center">
                <div class="col" style="flex-shrink: 1; flex-grow: 0; white-space: nowrap;">
                    <a @click="$emit('back')" class="mr-3" style="cursor: pointer">
                        <span class="bi bi-arrow-left-circle-fill"></span>
                    </a>
                    <slot name="nav" />
                </div>
                <div class="col text-right" style="white-space: nowrap;">
                    <button :disabled="!hasPrev" @click="$emit('prev')" class="btn btn-sm btn-light mr-1">
                        <i class="bi bi-arrow-left"></i>
                    </button>

                    <span @click="showPopup">
                        Въпрос {{ currentQuestion }} / {{ totalQuestions }}
                    </span>

                    <button :disabled="!hasNext" @click="$emit('next')" class="btn btn-sm btn-light ml-1">
                        <i class="bi bi-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal" id="selector-modal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <ul>
                            <li v-for="question in allowedQuestions" :key="question" @click="navigateToQuestion(question)" :class="{ 'current': question == currentQuestion }">
                                <div>
                                    {{ question }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jQuery from 'jquery';

    export default {
        props: {
            currentQuestion: {
                required: true,
                type: Number,
            },
            totalQuestions: {
                required: true,
                type: Number,
            },
            hasPrev: {
                required: false,
                type: Boolean
            },
            hasNext: {
                required: false,
                type: Boolean
            },
            allowedQuestions: {
                required: true,
                type: Number,
            },
        },

        data() {
            return {
                selectedQuestion: this.currentQuestion,
            }
        },

        watch: {
            currentQuestion(value) {
                this.selectedQuestion = value;
            }
        },

        methods: {
            showPopup() {
                jQuery('#selector-modal').modal('show');

                let x = (jQuery(window).height() - 56) / 2;
                let scroll = this.currentQuestion * 38 - x + 16;

                this.$nextTick(
                    () => jQuery('#selector-modal .modal-body').scrollTop(scroll)
                );
            },

            navigateToQuestion(value) {
                jQuery('#selector-modal').modal('hide');

                if (value !== this.selectedQuestion) {
                    this.$emit('navigateToQuestion', value)
                }
            }
        }
    }
</script>